import React, {
  useState,
  FormEvent,
  FormEventHandler,
  useEffect,
  useRef,
} from 'react';
import { Col, Button, Modal, Input, message as Message } from 'antd';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { store } from '../../../store';
import i18n from 'i18next';
import { ModalSuccess } from '../../layout/Modal';

import EmailSentIcon from '../../../assets/images/png/email-sent.png';
import { getAppGlobalState } from '../../../store/app-globals/selectors';
import { acceptOrRefuseOrder } from '../../../store/orders/actions';
import { fnCheckForRestrictedWords } from '../../../constants/resctrictedWords';

export interface ReportCookState {
  cookid: string;
  guestid: string;
  type: string;
}

export interface ProfileReportProps {
  reports: ReportCookState;
}

export interface RefuseOrderState {
  refuseMessage: string;
}

const initRefuseState: RefuseOrderState = {
  refuseMessage: '',
};

export interface RefuseOrderProps {
  orderid: string;
  guestid: string;
}

const GlobalModalProps = {
  icon: null,
  false: true,
  className: 'report-modal',
  okButtonProps: { style: { display: 'none' } },
};

export const closeModal = () => {
  Modal.destroyAll();
};

export const RefuseOrderContent: React.FC<RefuseOrderProps> = ({
  orderid,
  guestid,
}) => {
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const [refuse, setMessage] = useState<RefuseOrderState>(initRefuseState);
  const isSendingReport = useRef(false);
  const dispatch = useDispatch();
  const handleFieldChange = (
    field: keyof RefuseOrderState
  ): FormEventHandler => (e: FormEvent<HTMLInputElement>): void => {
    setMessage({ ...refuse, [field]: e.currentTarget.value });
    // console.log(refuse.refuseMessage);
  };

  const handleContinueButton = () => {
    closeModal();
  };

  const modalSucessContent = {
    icon: null,
    false: true,
    className: 'report-modal',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <ModalSuccess
        icon={EmailSentIcon}
        message={i18n.t('REPORT_REASON')}
        onClick={handleContinueButton}
      />
    ),
  };

  const handleSubmitButton = () => {
    if (fnCheckForRestrictedWords(refuse.refuseMessage)) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }
    if (refuse.refuseMessage !== '') {
      dispatch(
        acceptOrRefuseOrder(orderid, 'refused', refuse.refuseMessage, guestid)
      );
      isSendingReport.current = true;
    }
  };

  const refusinggOrders = () => {
    if (isSendingReport.current && !isLoading && !hasError) {
      closeModal();
      Modal.info(modalSucessContent);
    }
    if (isSendingReport.current && !isLoading && hasError) {
      // Message.error('Somwething went wrong');
      closeModal();
      Modal.info(modalSucessContent);
    }
  };

  useEffect(refusinggOrders, [isLoading]);

  return (
    <div>
      <Col className="input-field-container">
        <Input.TextArea
          placeholder={`${i18n.t('Write a reason of reporting')}...`}
          className="input-field"
          value={refuse.refuseMessage}
          onChange={handleFieldChange('refuseMessage')}
        />
      </Col>
      <Col span={24} className="report-button">
        <Button
          block
          type="primary"
          shape="round"
          className="send-report-button"
          loading={isLoading}
          onClick={handleSubmitButton}
          style={refuse.refuseMessage === '' ? { opacity: 0.4 } : {}}
        >
          <span className="continue-button-text">
            {message || i18n.t('Send')}
          </span>
        </Button>
      </Col>
      <Col span={24} className="report-button">
        <Button
          type="default"
          onClick={closeModal}
          className="cancel-report-button"
        >
          <span>{i18n.t('Cancel')}</span>
        </Button>
      </Col>
    </div>
  );
};

export const RefuseOrderHandler = ({ orderid, guestid }: RefuseOrderProps) => {
  Modal.info({
    ...GlobalModalProps,
    title: (
      <div className="report-modal-title">
        <span>{i18n.t('REFUSE_ORDER')}</span>
        <div className="modal-title-separator" />
      </div>
    ),
    content: (
      <Provider store={store}>
        <RefuseOrderContent orderid={orderid} guestid={guestid} />
      </Provider>
    ),
  });
};
